import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, EMPTY, catchError, mergeMap, timer } from 'rxjs';

interface NetworkInformationLike {
  effectiveType?: string;
  saveData?: boolean;
}

@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  private preloadIndex = 0;

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload'] !== true || this.shouldReduceNetworkWork()) {
      return EMPTY;
    }

    const delay = 1200 + this.preloadIndex++ * 350;
    return timer(delay).pipe(
      mergeMap(() => load()),
      catchError(() => EMPTY)
    );
  }

  private shouldReduceNetworkWork(): boolean {
    if (typeof navigator === 'undefined') {
      return false;
    }

    const connection = (navigator as Navigator & { connection?: NetworkInformationLike }).connection;
    return !!connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType ?? '');
  }
}
